
import { Component, Vue } from "vue-property-decorator";
import {
  addItemUserGroup,
  updateItemUserGroup,
  getItemUserGroupUserList,
  getStaffList,
} from "@/api/grayRelease";
import config from "@/config";
import storage from "@/utils/storage";

type IStaffItem = IResponse.GrayRelease.IStaffItem;

@Component({})
export default class UserGroupModal extends Vue {
  public apiBaseUrl: string = config.apiBaseUrl;
  public token: string = storage.localGet("version_user_info").token;
  public visible: boolean = false;
  public form: any;
  public formItemLayout: object = {
    labelCol: { span: 3 },
    wrapperCol: { span: 20 },
  };
  public checkedKeys: string[] = [];
  public userGroupId: string = "";
  public staffList: IStaffItem[] = [];
  public staffLoading: boolean = false;
  public userGroupUserLoading: boolean = false;
  public uploadLoading: boolean = false;

  public beforeCreate(): void {
    this.form = this.$form.createForm(this);
  }

  public filterStaffOption(input: string, option: any) {
    const userID =
      option?.componentOptions?.propsData?.value ?? option?.props?.value;
    const staff = this.staffList.find((s) => s.userID === userID);
    return staff
      ? staff.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
      : false;
  }

  public async onChangeVisible(userGroup?: { id: string; name: string }) {
    this.visible = !this.visible;
    if (this.visible) {
      if (this.staffList.length === 0) {
        await this.fetchStaffList();
      }
      userGroup &&
        this.$nextTick(() => {
          this.initUserGroupForm(userGroup);
        });
    } else {
      this.form.resetFields();
      this.checkedKeys = [];
      this.userGroupId = "";
    }
  }

  public async fetchStaffList() {
    this.staffLoading = true;
    try {
      const response = await getStaffList();
      if (response.status && response.data) {
        this.staffList = response.data;
      } else {
        this.$message.error(response.message || "获取员工列表失败");
      }
    } catch (error) {
      this.$message.error((error as Error).message || "获取员工列表失败");
    } finally {
      this.staffLoading = false;
    }
  }
  public async initUserGroupForm(userGroup: { id: string; name: string }) {
    this.userGroupId = userGroup.id;
    this.form.setFieldsValue({ name: userGroup.name });
    this.userGroupUserLoading = true;
    try {
      const response = await getItemUserGroupUserList(userGroup.id);
      if (!response.status) {
        this.$message.error(response.message);
        return;
      }
      const userIds = response.data.categories.map((item) => item.userID);
      this.checkedKeys = userIds;
    } finally {
      this.userGroupUserLoading = false;
    }
  }
  public onSubmit() {
    this.form.validateFields(async (err: object, values: { name: string }) => {
      if (!err) {
        try {
          const itemId = this.$route.query.id as string;
          const userIds = this.checkedKeys;
          const addRequest = {
            itemId,
            name: values.name,
            itemGroupUser: userIds,
          };
          const updateRequest = {
            id: this.userGroupId,
            itemId,
            name: values.name,
            itemGroupUser: userIds,
          };
          let response;
          if (this.userGroupId) {
            response = await updateItemUserGroup(updateRequest);
          } else {
            response = await addItemUserGroup(addRequest);
          }
          if (!response.status) {
            this.$message.error(response.message);
            return;
          }
          this.$message.success("Success!");
          this.$emit("refresh");
          this.onChangeVisible();
        } catch (error) {
          this.$message.error(error as string);
        }
      }
    });
  }

  public userGroupUserUploadHandleChange(info: any) {
    if (info.file?.status === "uploading") {
      this.uploadLoading = true;
    } else if (info.file?.status === "done" || info.file?.status === "error") {
      this.uploadLoading = false;
      if (info.file?.response) {
        if (info.file?.response?.status) {
          this.$message.success("批量上传成功");
          this.checkedKeys = info.file?.response.groupUserStaff.map(
            (item: any) => item.userID,
          );
        } else {
          this.$message.error(info.file?.response?.message);
        }
      }
    }
  }
}
